
export const Init_Board = 'Init_Board'
export const Set_Move = 'Set_Move'
export const Get_Game = 'Get_Game'
export const Surrender = 'Surrender'
export const Draw = 'Draw'
export const Set_Promotion = 'Set_Promotion'
export const Init_Single_Game = "Init_Single_Game";
export const Add_Move = 'Add_Move'